export function pluralForm($i, $str1, $str2, $str3, notWithCount) {
  var $m100 = $i % 100;
  var $m10 = $m100 % 10;
  if ($m10 === 1 && $m100 !== 11)
    return arguments[4] ? arguments[1] : $i + " " + arguments[1];
  else if ($m10 >= 2 && $m10 <= 4 && ($m100 < 10 || $m100 >= 20))
    return arguments[4] ? arguments[2] : $i + " " + arguments[2];
  else return arguments[4] ? arguments[3] : $i + " " + arguments[3];
}

export function getDayLabelNumber(count, notWithCount) {
  return pluralForm(count, "день", "дня", "дней", notWithCount);
}

export function getItemsLabelNumber(count, notWithCount) {
  return pluralForm(count, "вещь", "вещь", "вещей", notWithCount);
}

export function getBiletsLabelNumber(count, notWithCount) {
  return pluralForm(count, "билет", "билета", "билетов", notWithCount);
}

export function getGramsLabelNumber(count, notWithCount) {
  return pluralForm(count, "грамм", "грамма", "граммов", notWithCount);
}

export function getFilialsLabelNumber(count, notWithCount) {
  return pluralForm(count, "филиал", "филиала", "филиалов", notWithCount);
}

export function getProbsLabelNumber(count, notWithCount) {
  return pluralForm(count, "проба", "пробы", "проб", notWithCount);
}

export function getActionsLabelNumber(count, notWithCount) {
  return pluralForm(count, "действие", "действия", "действий", notWithCount);
}

export function getOperationsLabelNumber(count, notWithCount) {
  return pluralForm(count, "операция", "операции", "операций", notWithCount);
}

export function getBiletsEndLabelNumber(count, notWithCount) {
  return pluralForm(
    count,
    "заканчивается",
    "заканчиваются",
    "заканчиваются",
    notWithCount
  );
}

export function getBiletsExpiredLabelNumber(count, notWithCount) {
  return pluralForm(
    count,
    "просроченный",
    "просроченных",
    "просроченных",
    notWithCount
  );
}
